import { Outlet, useLoaderData, useParams } from "react-router-dom";

import { RoomLayout } from "@/deal-room/layout";
import { roomPath } from "@/deal-room/room-path";
import type { Room } from "@/deal-room/schema";

// /<type>/preview/:slug shell. Open preview path (no auth gate). Mirrors the
// production RoomShell — only the basePath differs.
export function PreviewRoomShell() {
    const room = useLoaderData() as Room;
    const params = useParams<{ slug: string; page?: string }>();
    const currentPageSlug = params.page ?? room.pages[0]?.slug ?? "";

    return (
        <RoomLayout
            room={room}
            currentPageSlug={currentPageSlug}
            basePath={roomPath(room.slug, true, room.roomType)}
        >
            <Outlet />
        </RoomLayout>
    );
}
